import React, { useEffect, useState } from "react";
import { Megaphone, X } from "lucide-react";
import api from "../lib/api";

const AnnouncementBanner = () => {
  const [item, setItem] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    api.get("/announcements", { params: { active_only: true } })
      .then((r) => {
        const latest = r.data[0];
        if (!latest) return;
        const dismissedId = sessionStorage.getItem("ips_dismissed_announcement");
        if (dismissedId === latest.id) setDismissed(true);
        setItem(latest);
      })
      .catch(() => {});
  }, []);

  if (!item || dismissed) return null;

  const close = () => {
    sessionStorage.setItem("ips_dismissed_announcement", item.id);
    setDismissed(true);
  };

  return (
    <div className="pt-20 px-4" data-testid="announcement-banner">
      <div className="max-w-5xl mx-auto">
        <div className="bg-brand-yellow rounded-2xl shadow-[0_10px_30px_rgba(252,216,52,0.35)] px-4 sm:px-6 py-3 flex items-start sm:items-center gap-3 animate-float-up">
          <div className="w-9 h-9 rounded-full bg-white flex items-center justify-center flex-shrink-0">
            <Megaphone size={18} className="text-brand-blue" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="font-heading font-bold text-sm sm:text-base text-[color:var(--text-primary)] leading-tight">{item.title}</div>
            <div className="text-xs sm:text-sm text-[color:var(--text-primary)]/85 mt-0.5 leading-snug">{item.body}</div>
          </div>
          <button onClick={close} className="text-[color:var(--text-primary)]/70 hover:text-[color:var(--text-primary)] p-1 rounded-full" aria-label="Dismiss" data-testid="announcement-dismiss">
            <X size={18} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default AnnouncementBanner;
